import { BulkListingPriceCalculation, Seating } from 'src/WebApiController';

import {
  ComparableListingDisplay,
  ComparableListingDisplayProps,
} from '../../ComparableListingDisplay';
import { ComparableListing } from '../ComparableListings';

export type ConnectedComparableListingDisplayProps = Pick<
  ComparableListingDisplayProps,
  'isCurrentListing'
> & {
  listing: ComparableListing;
  listingPriceCalculations?: BulkListingPriceCalculation[] | null;
  comparableListings?: ComparableListing[] | null;
  isExcludingFanInventory?: boolean;
};

export const ConnectedComparableListingDisplay: React.FC<
  ConnectedComparableListingDisplayProps
> = ({
  listing: {
    listingId,
    section,
    row,
    price,
    unitCost,
    currencyCode,
    isOutlier,
    isAnchor,
    isYourListing,
    isListed,
    isFanInventory,
    isSelectedWithListingGroup,
    validPurchaseQuantities,
    listingNotes,
    autoPricingResultType,
    autoPricingResultConstraintType,
    shouldShowResultTypeAction,
  },
  listingPriceCalculations,
  comparableListings,
  isExcludingFanInventory,
  ...props
}) => {
  if (price == null || currencyCode == null) {
    return null;
  }

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currencyCode,
  });

  return (
    <ComparableListingDisplay
      {...props}
      listingId={listingId}
      isOutlier={isOutlier}
      isAnchor={isAnchor}
      isYourListing={isYourListing}
      isListed={isListed}
      isFanInventory={isFanInventory}
      isSelectedWithListingGroup={isSelectedWithListingGroup}
      price={formatter.format(price)}
      unitCost={unitCost ? formatter.format(unitCost) : undefined}
      validPurchaseQuantities={validPurchaseQuantities}
      listingNotes={listingNotes}
      listingPriceCalculations={listingPriceCalculations}
      comparableListings={comparableListings}
      seating={
        {
          section: section ?? '',
          row: row ?? '',
        } as Seating
      }
      isExcludingFanInventory={isExcludingFanInventory}
      autoPricingResultType={autoPricingResultType}
      autoPricingResultConstraintType={autoPricingResultConstraintType}
      shouldShowResultTypeAction={shouldShowResultTypeAction}
    />
  );
};
